import { render, staticRenderFns } from "./IcoPhone.vue?vue&type=template&id=ccdc9188"
import script from "./IcoPhone.vue?vue&type=script&lang=js"
export * from "./IcoPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports